module.exports = __webpack_public_path__ + "c3993e8a9c5e4404b513ca2675c74f9b.pdf";